// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__Adtvj","content":"styles_content__2aBnQ","selectAll":"styles_selectAll__1IQ7R"};